module.exports = __webpack_public_path__ + "static/kesem-3-fd0b18d4c63df3eedc444f1106c66f80.jpg";